<template>
  <div>
    <!-- 页头 -->
    <el-card style="margin-bottom: 10px" shadow="never">
      <el-page-header @back="goBack" content=""> </el-page-header>
    </el-card>
    <!-- 内容 -->
    <el-card shadow="never">
      <div class="section-item-content">
        <!-- 节信息 -->
        <div style="margin-bottom: 50px">
          <div class="title-and-eidt">
            <span class="title"
              >{{ item.chapter_name }} : {{ item.section_name }}</span
            >
          </div>
        </div>
        <!-- 节内容 -->
        <div v-loading="loading">
          <editor-content
            title="课程内容："
            :attribuite="1"
            @save="saveContentButton"
            :show_content="content"
          ></editor-content>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import EditorModify from "../../components/common/modify/EditorV2Modify";
export default {
  name: "content-and-modify",
  components: {
    "editor-content": EditorModify,
  },
  data() {
    return {
      loading: true,
      item: {},
      section_id: null,
      content: "",
    };
  },
  mounted() {
    this.loading = true;
    this.item = this.$route.query;
    this.$http
      .get(`/get_section_content?section_id=${this.item.section_id}`)
      .then((res) => {
        this.content = res.data.data;
        this.loading = false;
      });
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "course_content_manage",
        query: {
          course_id: this.item.course_id,
        },
      });
    },
    saveContentButton(content) {
      // console.log(content);
      // return;
      let option = {
        section_id: this.item.section_id,
        section_content: content,
      };
      this.$http.post("/renew_section_content", option).then((res) => {
        console.log(res);
        this.content = res.data.data;
      });
    },
  },
};
</script>

<style>
.title-and-eidt {
  border-left: 5px solid #ff5420;
  padding: 0 5px;
  margin-bottom: 10px;
}

.title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
}

.section-item-content {
  padding: 5%;
  height: 100%;
}
</style>